import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
  updateDoc,
  addDoc,
  setDoc,
} from "firebase/firestore";

import { db, getUserName } from "../apis/auth";

const configCollection = "slc_config";
const zoneContactDoc = "zone_contacts";
const zoneComMob = "com_list";
const settingsCollection = "settings"

export async function getZoneContact() {
  console.log(`===> ${configCollection}-Query : getZoneContact()`);
  const docRef = doc(db(), configCollection, zoneContactDoc);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    const record = docSnap.data();
    return Promise.resolve(record);

  }
  return Promise.reject("Unable to get zone contact");
}

export async function getZoneComMob() {
  console.log(`===> ${configCollection}-Query : getZoneContact()`);
  const docRef = doc(db(), configCollection, zoneComMob);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    const record = docSnap.data();
    return Promise.resolve(record);
  }
  return Promise.reject("Unable to get zone contact");
}


export const getDataFromAPICall = async (collectionName, docId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let configInfo = {};
      const result = {
        docId: '',
        configInfo: {}
      };

      const docRef = doc(db(), collectionName, docId);
      const docSnapshot = await getDoc(docRef);

      if (docSnapshot.exists()) {
        configInfo = docSnapshot.data();
        result.docId = docSnapshot.id;
        result.configInfo = configInfo;
      } else {
        resolve(result);
      }

      resolve(result);
    } catch (error) {
      reject(error);
    }
  });
};
// export const getDataFromAPICall = async (collectionName) => {
//   return new Promise(async (resolve, reject) => {
//     try {
//       let docId = null;
//       let scheduleInfo = "";
//       const result = {
//         docId: '',
//         configInfo: {}
//       };

//       const q = query(collection(db(), "settingsCollection"));
//       const querySnapshot = await getDocs(q);

//       querySnapshot.forEach((doc) => {
//         docId = doc.id;
//         scheduleInfo = doc.data();
//       });

//       result.docId = docId;
//       result.configInfo = scheduleInfo ? scheduleInfo : {};

//       resolve(result);
//     } catch (error) {
//       reject(error);
//     }
//   });
// };

export const getHistoryFromAPICall = (history) => {
  return new Promise(async (resolve, reject) => {
    try {
      let historyList = [];
      const q = query(
        collection(db(), history),
        orderBy("ver", "desc")
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        const record = doc.data();
        historyList.push(record);
      });

      resolve(historyList); // Resolve the promise with the data (historyList)
    } catch (error) {
      reject(error); // Reject the promise if there was an error
    }
  });
};

export const createConfig = (configDocId, data) => {
  return new Promise(async (resolve, reject) => {
    if (configDocId) {
      if (data) {
        try {
          let currentVersion = parseInt(data.ver || 1, 10) + 1;
          const updatedData = {
            max_volt: parseFloat(data.max_volt, 10),
            min_volt: parseFloat(data.min_volt, 10),
            min_power_usage: parseFloat(data.min_power_usage, 10),
            max_power_usage: parseFloat(data.max_power_usage, 10),
            data_freq: parseFloat(data.data_freq, 10),
            ver: currentVersion,
          };
          const docRef = doc(db(), settingsCollection, configDocId);

          await updateDoc(docRef, updatedData);

          const newDocumentObj = {
            ...updatedData,
            user: await getUserName(),
            ch_dt: new Date(),
          };

          await addDoc(collection(db(), "cfg_upd_hist"), newDocumentObj);

          resolve("Config updated successfully"); // Return success message
        } catch (error) {
          console.error("Error updating schedule document or adding history: ", error);
          reject(error);
        }
      }
    } else {
      try {
        const newScheduleData = {
          max_volt: parseFloat(data.max_volt, 10),
          min_volt: parseFloat(data.min_volt, 10),
          min_power_usage: parseFloat(data.min_power_usage, 10),
          max_power_usage: parseFloat(data.max_power_usage, 10),
          data_freq: parseFloat(data.data_freq, 10),
          ver: 1,
        };
        const docRef = doc(db(), settingsCollection, "config");
        await setDoc(docRef, newScheduleData);
        // const docRef = await addDoc(collection(db(), settingsCollection), newScheduleData);
        const newDocumentObj = {
          max_volt: parseFloat(data.max_volt, 10),
          min_volt: parseFloat(data.min_volt, 10),
          min_power_usage: parseFloat(data.min_power_usage, 10),
          max_power_usage: parseFloat(data.max_power_usage, 10),
          data_freq: parseFloat(data.data_freq, 10),
          ver: 1,
          user: await getUserName(),
          ch_dt: new Date(),
        };

        await addDoc(collection(db(), "cfg_upd_hist"), newDocumentObj);

        resolve("Config created successfully");
      } catch (error) {
        console.error("Error creating schedule document or adding history: ", error);
        reject(error);
      }
    }
  });
};

export const handleSave = (DocId, Data, collectionName, id) => {
  // alert(`${DocId}==${JSON.stringify(Data)}===${collectionName}====${id}`)
  return new Promise(async (resolve, reject) => {
    if (DocId) {
      if (Data) {
        try {
          // let currentVersion = parseInt(Data.ver || 1, 10) + 1;
          // const updatedData = {
          //   url: Data.url,
          //   sha: Data.sha,
          //   ver: currentVersion
          // };
          // const docRef = doc(db(), collectionName, DocId);

          // await updateDoc(docRef, updatedData);

          const docRef = doc(db(), collectionName, DocId);
          const docSnapshot = await getDoc(docRef);

             const existingData = docSnapshot.data();

            const updatedData = {
              ...existingData,
              url: Data.url || existingData.url,
              sha: Data.sha || existingData.sha,
              ver: (parseInt(existingData.ver || 1, 10) + 1),
            };

            await updateDoc(docRef, updatedData).then(() => {
              resolve("Document updated successfully");
            });
         

        } catch (error) {
          console.error("Error updating schedule document or adding history: ", error);
          reject(error);
        }
      }
    } else {
      try {
        const newScheduleData = {
          url: Data.url,
          sha: Data.sha,
          ver: 1,
        };
        const docRef = doc(db(), collectionName, id);
        await setDoc(docRef, newScheduleData);
        // const docRef = await addDoc(collection(db(), collectionName), newScheduleData);
        resolve("Document created successfully");
      } catch (error) {
        console.error("Error creating schedule document or adding history: ", error);
        reject(error);
      }
    }
  });
};

